(ns frontend.view.grid.companies-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:asset/name
   :asset/description
   :company/website
   :asset/city
   :company/company-owner])

(def default-columns
  (set ordered-default-columns))

(def my-companies-ordered-columns
  [:asset/name
   :asset/description
   :company/website
   :asset/city])

(def my-companies-columns
  (set my-companies-ordered-columns))

;;always selected:
(def mandatory?
  #{:asset/name})
